import React from "react";
import { MonthDate } from "./types";
import { getEndingByCountLT4 } from "common/helpers/text.helpers";
import _ from "lodash";
import { getMonthDateRangeFromCurrentDate } from "../../helpers/comparableFilters.helpers";
import { Toggle } from "../form/toggle/Toggle";
import { useTranslation } from "react-i18next";

interface MonthRangePresetProps {
  selectedDatesInFilter?: { start: MonthDate; end: MonthDate };
  onSelect?: (startDate: MonthDate, endDate: MonthDate) => void;
  monthLength: number;
}

export const MonthRangePreset: React.FC<MonthRangePresetProps> = ({
  onSelect,
  monthLength,
  selectedDatesInFilter,
}) => {
  const { t, i18n } = useTranslation();
  const currentDate = new Date();
  const startDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - monthLength + 1,
    1
  );

  const startMonth = {
    year: startDate.getFullYear(),
    month: startDate.getMonth() + 1,
  };
  const endMonth = {
    year: currentDate.getFullYear(),
    month: currentDate.getMonth() + 1,
  };

  const isChecked =
    _.isEqual(startMonth, selectedDatesInFilter?.start) &&
    _.isEqual(endMonth, selectedDatesInFilter?.end);

  const label =
    i18n.language === "lt"
      ? `${monthLength} ${t("datepicker.presets.months")}${getEndingByCountLT4(
          monthLength
        ).toLowerCase()}`
      : `${monthLength} ${t("datepicker.presets.months")}`;

  return (
    <Toggle
      isChecked={isChecked}
      label={label}
      onSelect={() => {
        const dates = getMonthDateRangeFromCurrentDate(monthLength);
        onSelect?.(dates.startDate, dates.endDate);
      }}
    />
  );
};
